import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const columnHeadingDescriptionStart = 'Column heading for: ';
const pathStart = 'Catalogs|Emails|';
const sharedProperties: Pick<LocDef, 'feature' | 'htmlAllowed' | 'shared' | 'portal'> = {
	htmlAllowed: false,
	shared: false,
	portal: 'SP',
	feature: HubFeature.Core,
};

type LocNameStart = 'SPEmailCatalog';
export type SPEmailCatalogLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}LabelStatus`
	| `${LocNameStart}LabelFilterByStatus`
	| `${LocNameStart}LabelType`
	| `${LocNameStart}LabelFilterByType`
	| `${LocNameStart}LabelContext`
	| `${LocNameStart}LabelItem`
	| `${LocNameStart}LabelSubject`
	| `${LocNameStart}LabelFrom`
	| `${LocNameStart}LabelLanguages`
	| `${LocNameStart}ContentEmailStatusHidden`
	| `${LocNameStart}ContentEmailStatusDisabled`
	| `${LocNameStart}ContentEmailStatusActive`;

export const spEmailCatalogLocs: LocDefs<SPEmailCatalogLocNames> = {
	SPEmailCatalogTitlePage: {
		defaultValue: 'Email Catalog',
		description: 'Page Title',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'Core/Catalogs.Emails.Title.PageTitle',
		...sharedProperties,
	},
	SPEmailCatalogLabelStatus: {
		defaultValue: 'Status',
		description: `${columnHeadingDescriptionStart}Status`,
		displayPath: `${pathStart}Status`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.ColumnHeading.Status',
		...sharedProperties,
	},
	SPEmailCatalogLabelFilterByStatus: {
		defaultValue: 'Filter by Status',
		description: `Label for Filter by Status`,
		displayPath: `${pathStart}Filter by Status`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.FieldLabel.StatusFilter',
		...sharedProperties,
	},
	SPEmailCatalogLabelType: {
		defaultValue: 'Type',
		description: `${columnHeadingDescriptionStart}Type`,
		displayPath: `${pathStart}Type`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.ColumnHeading.Type',
		...sharedProperties,
	},
	SPEmailCatalogLabelFilterByType: {
		defaultValue: 'Filter by Type',
		description: `Label for Filter by Type`,
		displayPath: `${pathStart}Filter by Type`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.FieldLabel.TypeFilter',
		...sharedProperties,
	},
	SPEmailCatalogLabelContext: {
		defaultValue: 'Context',
		description: `${columnHeadingDescriptionStart}Context`,
		displayPath: `${pathStart}Context`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.ColumnHeading.Context',
		...sharedProperties,
	},
	SPEmailCatalogLabelItem: {
		defaultValue: 'Item',
		description: `${columnHeadingDescriptionStart}Item`,
		displayPath: `${pathStart}Item`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.ColumnHeading.Item',
		...sharedProperties,
	},
	SPEmailCatalogLabelSubject: {
		defaultValue: 'Subject',
		description: `${columnHeadingDescriptionStart}Subject`,
		displayPath: `${pathStart}Subject`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.ColumnHeading.Subject',
		...sharedProperties,
	},
	SPEmailCatalogLabelFrom: {
		defaultValue: 'From',
		description: `${columnHeadingDescriptionStart}From`,
		displayPath: `${pathStart}From`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.ColumnHeading.From',
		...sharedProperties,
	},
	SPEmailCatalogLabelLanguages: {
		defaultValue: 'Languages',
		description: `${columnHeadingDescriptionStart}Languages`,
		displayPath: `${pathStart}Languages`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.ColumnHeading.Languages',
		...sharedProperties,
	},
	SPEmailCatalogContentEmailStatusActive: {
		defaultValue: 'Active',
		description: `Email status: Active`,
		displayPath: `${pathStart}Active`,
		displayType: 'Content',
		legacyName: 'Core/Catalogs.Emails.Title.ActiveGroup',
		...sharedProperties,
	},
	SPEmailCatalogContentEmailStatusHidden: {
		defaultValue: 'Hidden',
		description: `Email status: Hidden`,
		displayPath: `${pathStart}Hidden`,
		displayType: 'Content',
		legacyName: 'Core/Catalogs.Emails.Title.HiddenGroup',
		...sharedProperties,
	},
	SPEmailCatalogContentEmailStatusDisabled: {
		defaultValue: 'Disabled',
		description: `Email status: Disabled`,
		displayPath: `${pathStart}Disabled`,
		displayType: 'Content',
		legacyName: 'Core/Catalogs.Emails.Title.DisabledGroup',
		...sharedProperties,
	},
};
export type SPEmailCatalogLocsType = LocMap<SPEmailCatalogLocNames>;
